<template>
  <b-form>
    <b-form-group
      v-for="agreement in agreements"
      :key="`form-group__agreement-${agreement.key}`"
      class="mt-3"
    >
      <b-form-checkbox
        :id="`checkbox__agreement-${agreement.key}`"
        :ref="`checkbox__agreement-${agreement.key}`"
        v-model="selected"
        :disabled="disabled"
        :value="`${agreement.key}`"
        name="agreement-options"
        disable-event-track
        @change.native="onChange($event, selected)"
      >
        <div>
          <div class="font-weight-bold">{{ agreement.title }}</div>
          <div>{{ agreement.description }}</div>
        </div>
      </b-form-checkbox>
    </b-form-group>
  </b-form>
</template>

<script>
import { amplitudeMixin } from '@/mixins/amplitudeMixin';

export default {
  mixins: [amplitudeMixin],

  model: {
    event: 'change',
    prop: 'isAgreed'
  },

  props: {
    topic: {
      type: String,
      required: true
    },

    cacheKey: {
      type: String,
      required: true
    },

    agreements: {
      type: Array,
      required: true
    },

    disabled: {
      type: Boolean,
      required: false
    },

    isAgreed: {
      type: Boolean,
      required: true
    },
    isSaveAgreement: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selected: []
    };
  },

  watch: {
    selected(value) {
      if (this.isSaveAgreement) {
        localStorage.setItem(`agreement_${this.topic}_${this.cacheKey}`, value);
      }

      const isAgreed = this.agreements.every(({ key }) => {
        return value.includes(`${key}`);
      });

      this.$emit('change', isAgreed);
    },
    cacheKey(value) {
      this.loadCookie(value)
    }
  },

  created() {
    this.loadCookie()
  },

  methods: {
    onChange(event, value) {
      this.$_amplitudeMixin_onChange(event.target, {
        Value: value
      });
    },
    loadCookie(value=this.cacheKey) {
      const cookie = localStorage.getItem(`agreement_${this.topic}_${value}`);
      if (cookie) {
        this.selected = cookie.split(',');
      } else {
        this.selected = [];
      }
    }
  }
};
</script>
